import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { MessageUtil } from '../../../utils/message.util';
import { EmailAccountService } from 'src/app/services/email-account.service';
import { StorageUtil } from 'src/app/utils/storage.util';

@Component({
  selector: 'app-header-button-user-config',
  templateUrl: './header-button-user-config.component.html',
  styleUrls: ['./header-button-user-config.component.scss']
})
export class HeaderButtonUserConfigComponent implements OnInit {
  menuItems: MenuItem[] = [];  
  infoUserCustomerBillingEmail: string = this.messageUtil.translateKey('EMAIL_NOT_REGISTERED');

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private messageUtil: MessageUtil,
    private emailAccountService: EmailAccountService
  ) {}

  ngOnInit(): void {
    this.loadMenuItems();
    this.getEmailInfo();
  }

  loadMenuItems(): void {
    this.translateService.get(['MY-INVOICE', 'CHAMADOS', 'MY-MARINE', 'EMAIL-BILLING', 'SUPER-INVOICING']).subscribe((translations: any) => {
      this.menuItems = [
        {
          label: translations['MY-INVOICE'],
          icon: 'pi pi-file',
          command: () => this.navigateToMyInvoices()
        },
        {
          label: translations['CHAMADOS'],
          icon: 'pi pi-ticket',
          command: () => this.navigateToTickets()
        },
        {
          label: translations['MY-MARINE'],
          icon: 'pi pi-compass',
          command: () => this.navigateToMyMarine()
        },
        {
          label: translations['EMAIL-BILLING'],
          icon: 'pi pi-envelope',
          command: () => this.openEmailBilling(),
          tooltipOptions: {
            tooltipLabel: this.infoUserCustomerBillingEmail,
            tooltipPosition: 'right',
            positionTop: -10,
            positionLeft: 5,
            tooltipStyleClass: 'email-tooltip-custom'
          }
        }
      ];
      
      const marinaId = StorageUtil.getMarinaId();
      if (marinaId === 109) {
        this.menuItems.push({
          label: translations['SUPER-INVOICING'],
          icon: 'pi pi-chart-bar',
          command: () => this.navigateToSuperInvoicing()
        });
      }
    });
  }

  navigateToMyInvoices(): void {
    this.router.navigate(['/app/my-account/my-invoice']);
  }

  navigateToTickets(): void {
    this.router.navigate(['/app/my-account/ticket']);
  }

  navigateToMyMarine(): void {
    this.router.navigate(['/app/my-account/my-marine']);
  }

  navigateToSuperInvoicing(): void {
    this.router.navigate(['/app/my-account/super-invoicing']);
  }

  openEmailBilling(): void {
    window.open('https://mail.google.com/mail/u/0/#inbox', '_blank');
  }

  getEmailInfo(): void {
    this.emailAccountService.getnumberOfMessages().subscribe(
      (data) => {
        if (data !== null) {
          this.infoUserCustomerBillingEmail = 'E-mail: '
            .concat(data.customerBillingEmail)
            .concat('\n')
            .concat('Senha: ')
            .concat(data.passwordEmailCustomerBilling);
          this.updateMenuItems();
        }
      },
      (error) => {
        console.error('Erro ao obter informações de e-mail:', error);
      }
    );
  }

  updateMenuItems(): void {
    const emailBillingItem = this.menuItems.find(item => item.command.toString().includes('openEmailBilling'));
    if (emailBillingItem) {
      emailBillingItem.tooltipOptions = {
        tooltipLabel: this.infoUserCustomerBillingEmail,
        tooltipPosition: 'right',
        positionTop: -10,
        positionLeft: 5,
        tooltipStyleClass: 'email-tooltip-custom'
      };
    }
  }
}
